import { ChangeEvent, ReactNode } from "react";
import {
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserData } from "types";

export interface NotificationsProps {
  readonly?: boolean;
  disabled?: boolean;
  data: UserData | undefined;
  setUserData?: (data: UserData) => void;
  hasMobilePhone?: boolean;
  hasEmailAddress?: boolean;
}

export const Notifications = ({
  readonly = false,
  disabled = false,
  hasMobilePhone = false,
  hasEmailAddress = false,
  data,
  setUserData,
}: NotificationsProps): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleNotificationTypeChange = ({
    target: { name, checked },
  }: ChangeEvent<HTMLInputElement>) => {
    if (!setUserData) return;

    let email = data?.notifications?.notificationType?.email;
    let text = data?.notifications?.notificationType?.text;

    if (name === "email") {
      email = checked;
    } else if (name === "text") {
      text = checked;
    }

    setUserData({
      ...data,
      notifications: {
        allowNotifications: true,
        notificationType: {
          email: email,
          text: text,
        },
      },
    });
  };

  return (
    <Stack
      direction={"column"}
      spacing={0}
      sx={mobile ? { border: `1px solid lightgray`, p: 2 } : {}}
    >
      <Typography
        variant={"subtitle1"}
        align={mobile ? "center" : "left"}
        textTransform={"capitalize"}
        mb={{ xs: 1, sm: 2, lg: 0 }}
      >
        {t("notifications", { ns: "userSettings" })}
      </Typography>
      <Stack direction={"row"} display={"flex"} spacing={2}>
        <FormControlLabel
          sx={{ flex: 1, textTransform: "capitalize" }}
          control={
            <Checkbox
              disabled={disabled || !hasMobilePhone || !setUserData}
              name="text"
              readOnly={readonly}
              checked={data?.notifications?.notificationType?.text}
              onChange={handleNotificationTypeChange}
            />
          }
          label={t("text", { ns: "userSettings" })}
        />
        <FormControlLabel
          sx={{ flex: 1, textTransform: "capitalize" }}
          control={
            <Checkbox
              name="email"
              disabled={disabled || !hasEmailAddress || !setUserData}
              readOnly={readonly}
              checked={data?.notifications?.notificationType?.email}
              onChange={handleNotificationTypeChange}
            />
          }
          label={t("email", { ns: "userSettings" })}
        />
      </Stack>
    </Stack>
  );
};
